import { Styles } from 'jss';
import * as cssVariable from 'cssVariables';
import tileStyles from 'tile-components-styles';

export default (theme: StyleTheme): Styles => ({
  title: {
    ...tileStyles.titleDefault,
    textTransform: 'none',
    marginTop: 12,
    minHeight: 25,
    lineHeight: 1.2,
    fontWeight: cssVariable.fontWeights.bold,
    fontSize: cssVariable.fontSizes.small,
    '& span': {
      fontSize: cssVariable.fontSizes.small,
      fontWeight: cssVariable.fontWeights.light,
      marginBottom: '5px',
    },
  },
  titleLink: {
    color: cssVariable.grey600,
    textDecoration: 'none',
    '&:hover': {
      color: cssVariable.green500,
    },
  },
  author: {
    marginTop: 5,
    fontSize: cssVariable.fontSizes.small,
  },
  backdropDefaultFix: {
    maxWidth: '99.7%',
    borderRadius: cssVariable.borderRadius.default,
  },
  ...tileStyles,
  podcastTile: {
    position: 'relative',
    transition: 'transform 300ms ease',
    display: 'block',
    backgroundColor: theme.palette.backgroundSecondary,
    paddingTop: '100%',
    borderRadius: cssVariable.borderRadius.default,
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  hoverOverlayDefault: {
    ...tileStyles.hoverOverlayDefault,
    borderRadius: cssVariable.borderRadius.default,
  },
  noHover: {
    '&:hover': {
      opacity: 0,
    },
    '&:focus': {
      opacity: 0,
    },
  },
  hoverBackdropDefault: {
    ...tileStyles.hoverBackdropDefault,
    borderRadius: cssVariable.borderRadius.default,
  },
  link: {
    position: 'absolute',
    left: 10,
    bottom: 5,
    fontSize: 13,
    fontWeight: cssVariable.fontWeights.light,
    color: cssVariable.white,
    textDecoration: 'none',
  },
  chevron: {
    verticalAlign: 'middle',
    marginTop: -4,
    height: 26,
    width: 26,
  },
  addToFavoritesButton: {
    border: 'none',
    background: 'none',
    top: 5,
    right: 5,
    position: 'absolute',
    cursor: 'pointer',
    color: cssVariable.white,
    '& > svg': {
      width: 17,
      height: 17,
    },
    '&:disabled': {
      opacity: 0,
      cursor: 'auto',
    },
  },
  [theme.breakpoints.down('sm')]: {
    chevron: {
      display: 'none',
    },
  },
});
